import React from 'react';

interface BoltIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const BoltIcon: React.FC<BoltIconProps> = ({
    width = 16,
    height = 16,
    color = '#FFCD00'
}) => {
    return (
        <svg height={height} width={width} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 337.19 337.19" xmlSpace="preserve">
            <g>
                <polygon style={{ fill: color }} points="168.595,0 168.595,204.521 276.356,204.521 	" />
                <polygon style={{ fill: color }} points="60.834,132.669 168.595,337.19 168.595,132.669 	" />
            </g>
        </svg>
    );
};

export default BoltIcon;
